import React, { useEffect, useState, createElement } from 'react';
import { EditorialVariant } from './components/EditorialVariant';
import { DocumentaryVariant } from './components/DocumentaryVariant';
import { ScientificVariant } from './components/ScientificVariant';
import { TestimonialVariant } from './components/TestimonialVariant';
import { Layout, Camera, Activity, Heart } from 'lucide-react';
// Meta Pixel implementation
// Note: You'll need to install react-facebook-pixel first:
// npm install react-facebook-pixel
// or
// yarn add react-facebook-pixel
// Uncomment these imports once the package is installed:
// import ReactPixel from 'react-facebook-pixel';
export function App() {
  const [activeVariant, setActiveVariant] = useState<string>('editorial');
  // Initialize Meta Pixel on component mount
  useEffect(() => {
    // Uncomment this block once react-facebook-pixel is installed:
    /*
    const options = {
      autoConfig: true, // set pixel's autoConfig
      debug: false, // enable logs
    };
    ReactPixel.init('1029238155326534', undefined, options);
    ReactPixel.pageView(); // Track initial page view
    */
    // Manual implementation (fallback if package isn't installed)
    if (typeof window !== 'undefined') {
      // Facebook Pixel Code
      ;
      (function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = true;
        t.src = v;
        // Append to head instead of inserting before first script
        b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1029238155326534');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  // Track variant changes as custom events
  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('trackCustom', 'VariantView', {
        variant: activeVariant
      });
    }
    // If using react-facebook-pixel package, use this instead:
    // ReactPixel.trackCustom('VariantView', { variant: activeVariant });
  }, [activeVariant]);
  const renderVariant = () => {
    switch (activeVariant) {
      case 'editorial':
        return <EditorialVariant data-id="element-0" />;
      case 'documentary':
        return <DocumentaryVariant data-id="element-1" />;
      case 'scientific':
        return <ScientificVariant data-id="element-2" />;
      case 'testimonial':
        return <TestimonialVariant data-id="element-3" />;
      default:
        return <EditorialVariant data-id="element-4" />;
    }
  };
  return <div className="relative" data-id="element-5">
      {/* Noscript fallback for Meta Pixel */}
      <noscript data-id="element-6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1029238155326534&ev=PageView&noscript=1" alt="" data-id="element-7" />
      </noscript>

      {/* Variant Switcher - Fixed at bottom right */}
      <div className="fixed bottom-6 right-6 z-[100] bg-white/90 backdrop-blur shadow-2xl rounded-full p-2 border border-slate-200 flex gap-2" data-id="element-8">
        <button onClick={() => setActiveVariant('editorial')} className={`p-3 rounded-full transition-all ${activeVariant === 'editorial' ? 'bg-stone-900 text-white' : 'hover:bg-slate-100 text-slate-500'}`} title="Editorial Style" data-id="element-9">
          <Layout size={20} data-id="element-10" />
        </button>
        <button onClick={() => setActiveVariant('documentary')} className={`p-3 rounded-full transition-all ${activeVariant === 'documentary' ? 'bg-blue-600 text-white' : 'hover:bg-slate-100 text-slate-500'}`} title="Documentary Style" data-id="element-11">
          <Camera size={20} data-id="element-12" />
        </button>
        <button onClick={() => setActiveVariant('scientific')} className={`p-3 rounded-full transition-all ${activeVariant === 'scientific' ? 'bg-[#0EA5E9] text-white' : 'hover:bg-slate-100 text-slate-500'}`} title="Scientific Style" data-id="element-13">
          <Activity size={20} data-id="element-14" />
        </button>
        <button onClick={() => setActiveVariant('testimonial')} className={`p-3 rounded-full transition-all ${activeVariant === 'testimonial' ? 'bg-pink-500 text-white' : 'hover:bg-slate-100 text-slate-500'}`} title="Testimonial Style" data-id="element-15">
          <Heart size={20} data-id="element-16" />
        </button>
      </div>

      {renderVariant()}
    </div>;
}